<p>
The main artwork is 300dpi Giclée printed on art paper,
using sustainably sourced paper and water-based (plastic-free) inks, in the
UK. <br/>The accompanying booklet is laser printed on recycled paper in Lyon, France.
</p>
